<template>
  <div class="row" style="margin-left: 0px;margin-right: 0px;">
          <div class=" col-xs-12" style="padding:0px;margin:0px" v-if="clearingAll == false">
            <div class=" col-xs-6" style="padding:0px;margin:0px">
              <select
                class="form-control select-box limited-height-box"
                style="width:100%!important;margin-top: 0px;font-size:12px;"
                :disabled="allDisabled"
                @change="onFilterTypeSelected($event.target.value)"
                :id="'search_block'+block_id"
                :name="'search_block'+block_id"
                :value="selectedFieldName"
              >
                <option  value=""></option>
                <option v-for="o in filedList" :data="o" :key="o.id" :value="o.id">{{ o.label }}</option>
              </select>
            </div>
            <div class=" col-xs-6" style="padding:0px 0px 0px 3px;margin:0px;">
              <div v-if="selectedFieldType == false">
                ...
              </div>
              <div v-else-if="selectedFieldType == filed_types.INPUT || selectedFieldType == filed_types.PASSWORD || selectedFieldType == filed_types.TEXT_AREA">
                <input 
                  :disabled="selected_field == false || allDisabled" 
                  ref="local_value" 
                  type="text" 
                  class="form-control" 
                  style="height:24px;font-size:12px;"
                  @input="updateValue($event.target.value)" 
                  :id="'search_local_value_'+block_id"  name="local_value"  :model="localValue" :value="localValue" >
              </div>
              <div v-else-if="selectedFieldType == filed_types.SELECT_BOX && (selectedField.id == 'data_name' || selectedField.id == 'operation_type')"> <!-- Only for history -->
                  <select  class="form-control select-box limited-height-box"
                :disabled="selected_field == false || allDisabled" 
                style="height:24px;font-size:12px;"
                  @change="updateValue($event.target.value)" 
                  :id="'search_local_value_'+block_id"  name="local_value"  :model="localValue" :value="localValue">
                      <option disabled></option>
                      <option v-for="o in fieldOptions" v-bind:data="o.val" v-bind:key="o.val" :value="o.val">{{o.label}}</option>
                      <option value="SELECTED_EMPTY_SELECT_BOX" v-if="selectedField.search_no_blank != true">(空白)</option>
                  </select>
              </div>
              <div v-else-if="selectedFieldType == filed_types.SELECT_BOX || selectedFieldType == filed_types.SELECT_BOX3">
                <select  class="form-control select-box limited-height-box"
                :disabled="selected_field == false || allDisabled"
                style="height:24px;font-size:12px;"
                  @change="updateValue($event.target.value)" 
                  :id="'search_local_value_'+block_id"  name="local_value"  :model="localValue" :value="localValue">
                  <option></option>
                  <option v-for="o in fieldOptions"  v-bind:data="o" v-bind:key="o" val="." :selected="localValue == o">{{o}}</option>
                  <option v-if="selectedFieldType == filed_types.SELECT_BOX3 " value="manual_input">手動入力検索</option>
                  <option value="SELECTED_EMPTY_SELECT_BOX" v-if="selectedField.search_no_blank != true">(空白)</option>
                </select>
              </div>
              <div v-else-if="selectedFieldType == filed_types.SELECT_BOX4">
                <select-box4 
                :data="selected_field" 
                value=""
                :search_value="localValue" 
                :option="{hide_label:true,search_mode:true,search_block_id:this.block_id}" 
                :read="false"
                @change="updateValue" 
                 search></select-box4>
              </div>
              <div v-else-if="selectedFieldType == filed_types.SELECT_BOX2">
                  <select  class="form-control select-box limited-height-box"
                    style="height:24px;font-size:12px;"
                    @change="updateValue($event.target.value)" 
                    :disabled="selected_field == false || allDisabled"
                    :id="'search_local_value_'+block_id" name="local_value"  :model="localValue" :value="localValue">
                    <option v-for="o in fieldOptions"   :data="o.value" :key="o.value" :value="o.value">{{o.label}}</option>
                  </select>
              </div>
              <div v-else-if="selectedFieldType == filed_types.DATETIME_PICKER" >
                 <datetimepicker
                 :calendarButton="true"
                  inputButtonStyle="padding-left: 3px!important;padding-right: 3px!important;"
                  :disabled-picker="selected_field == false || allDisabled" 
                  style="margin-left:8px;margin-top: 0px;"
                  :input-style="(selected_field == false || allDisabled)?'border-radius: 4px;font-size:12px;' : 'border-radius: 4px;background-color: white;font-size:12px;'"
                  input-class=" form-control force-white limited-height-box"
                  @input="updateValueDateTime"
                  id="datetimepicker"
                  name="datetimepicker"
                  :model="localValue" 
                  :value="localValue"
                  placeholder=""
                  calendar-style="left:-100px;"
                ></datetimepicker>
              </div>
              <div v-else-if="selectedFieldType == filed_types.DATE_PICKER  || selectedFieldType == filed_types.CURRENT_TIME " >
                 <datepicker
                 :calendarButton="true"
                  inputButtonStyle="padding-left: 3px!important;padding-right: 3px!important;"
                  :disabled-picker="selected_field == false || allDisabled" 
                  style="margin-left:8px;margin-top: 0px;"
                  :input-style="(selected_field == false || allDisabled)?'border-radius: 4px;font-size:12px;' : 'border-radius: 4px;background-color: white;font-size:12px;'"
                  input-class=" form-control force-white limited-height-box"
                  @input="updateValueDate"
                  id="datepicker"
                  name="datepicker"
                  :model="localValue" 
                  :value="localValue"
                  placeholder=""
                  calendar-style="left:-100px;"
                ></datepicker>
              </div>
              <div v-else-if="selectedFieldType == filed_types.RADIO_BUTTON">
                TBA
                <!-- <radio-button :data="fieldInfo" :value="valinfo"  :option="optionInfo"  :read="readOnly"  ></radio-button> -->
              </div>
              <div v-else-if="selectedFieldType == filed_types.CHECKBOX">
                TBA
                <!-- <checkbox :data="fieldInfo" :value="valinfo"  :option="optionInfo"  :read="readOnly"  ></checkbox> -->
              </div>
              <div v-else>
                <div class="form-group esma_form_group" ><br></div>
              </div>
            </div>
          </div>
          <input-modal :tag="'showInputModal' + block_id" @inputed="updateValue" @closed="onManualSelectClose"></input-modal>
      </div>
</template>

<script>
import Vue from 'vue'
import { bus } from '@/libs/bus'
import debug from 'debug';
import moment from 'moment';
import _ from 'lodash';
var debug_search_control_block = debug('esma:search_control_block');
import { filed_types } from '@/constants/field_types'
import inputModal from "@/components/modals/input-modal";
import selectBox4 from "@/components/fields/select-box4";


export default {
    components: {
    "select-box4": selectBox4,
    "input-modal": inputModal
  },
  data() {
    return {
      local_value:"",
      filed_types:filed_types,
      selected_field:false,
      selected_field_type:filed_types.INPUT,
      field_options:[],
      clearing:false,
      selected_field_name :"",
      seqquence_refresh:1,
      enable_only_id:"all"

    };
  },
  computed: {
    enableOnlyId:{
      get(){
        return this.enable_only_id;
      },
      set(v){
        this.enable_only_id = v;
      }
    },
    seqquenceRefresh:{
      get(){
        return this.seqquence_refresh;
      },
      set(v){
        this.seqquence_refresh = v;
      }
    },
    selectedField:{
      get(){
        return this.selected_field;
      },
      set(v){
        this.selected_field = v;
      }
    },
    selectedFieldName:{
      get(){
        return this.selected_field_name;
      },
      set(v){
        this.selected_field_name = v;
      }
    },
    clearingAll:{
      get(){
        return this.clearing;
      },
      set(v){
        this.clearing = v;
      }
    },
    allDisabled(){
      return this.all_disabled == true
    },
    localValue:{
      get(){
        return this.local_value;
      },
      set(v){
        this.local_value = v;
      }
    },
    fieldOptions:{
      get(){
        return this.field_options;
      },
      set(v){
        this.field_options = v;
      }
    },
    selectedFieldType:{
      get(){
        return this.selected_field_type;
      },
      set(v){
        this.selected_field_type = v;
      }
    },
    filedList(){
      var local = this.field_names;


      if(this.enableOnlyId && this.enableOnlyId != "all"){
        local = _.filter(local,(l)=>{
          return l.id == this.enableOnlyId;
        })
      }

      var r =  (this.seqquenceRefresh > 0) ? local.map(o=>{
        return {id:o.id,label:o.label,type:o.type, search_dependency:o.search_dependency }
      }):[];
      return r;
    }
  },
  methods: {
    clearAll(){
      this.clearingAll = true;
      this.localValue = "*";
      this.updateValue("");
      this.localValue = "";
      this.selected_field =false;
      this.selectedFieldType = filed_types.INPUT
      this.selectedFieldName = "";
      setTimeout(()=>{
        this.clearingAll = false;
      },200)
    },
    onFilterTypeSelected(val, cb=()=>{}){

      this.selectedFieldName = val;
      this.localValue = "*";
      var f = _.find(this.field_names,{id:val})
      var wait_time = 1;
      if(typeof f != "undefiend" && f != null && f!= false && (f.type == filed_types.SELECT_BOX4 || f.type == filed_types.SELECT_BOX2)){
        this.selected_field =false;
        this.selected_field_type = false;
        wait_time = 100;
      }
      setTimeout(() => {
          console.log("before",f, typeof f)
          if(typeof f != "undefiend" && f != null && f!= false){
            this.selected_field  = f;
            this.selected_field_type = f.type;
            if( f.type == filed_types.SELECT_BOX || f.type == filed_types.SELECT_BOX3 || f.type == filed_types.SELECT_BOX2){
              var temp_options =  f.options_original || f.options;
              this.fieldOptions = _.clone(temp_options)
            }
          }else{
            this.selected_field =false;
          }
          this.localValue = "";
          console.log("onFilterTypeSelected",val,f)
          this.$emit("change",{block:this.block_id,field:this.selected_field.id,value:"",ct:"f",ca:this.clearingAll,t:this.selectedFieldType});
          return cb();
      }, wait_time);
   },
    onManualSelectClose(val){
        this.value_updated = true;
        if(this.fieldOptions.indexOf(val) < 0){
          var f = this.selected_field ;
          var temp_options =  f.options_original || f.options;
          this.fieldOptions = _.clone(temp_options)

          this.fieldOptions.unshift(val)
        }
        this.updateValue(val)
    },
    updateValue(v) {
      if(v == "manual_input"){
        console.log("manual_input INPUT");
          bus.$emit("showInputModal" + this.block_id, {
            title: "手動入力検索",
            initial_value:""
          });
          return
      }
      if(this.clearingAll == false && this.selectedFieldType == filed_types.SELECT_BOX && v == ""){
        v = "SELECTED_EMPTY_SELECT_BOX";
      }
      this.localValue = v
      if(typeof v != "undefined" && this.selected_field != false){
        this.$emit("change",{block:this.block_id,field:this.selected_field.id,value:v,ct:"v",ca:this.clearingAll,t:this.selectedFieldType});
      }
    },
    updateValueDate(v){
      if(v == null){
        return v;
      }
        this.updateValue(moment(v).format('YYYY/MM/DD'))
    },
    updateValueDateTime(v){
      if(v.length < 11){
        this.updateValue(moment(v).format('YYYY/MM/DD'))
      }else{
        if(moment(v).format('HH:mm') == "00:00"){
          this.updateValue(moment(v).format('YYYY/MM/DD'))
        }else{
          this.updateValue(moment(v).format('YYYY/MM/DD HH:mm'))
        }
      }
    },
    enableOnly(field_id){
      this.enableOnlyId = field_id;
      this.seqquenceRefresh++;
    }
  },
  beforeMount() {},
  mounted() {
    if(this.block_contorler){
      this.$props.block_contorler.enableOnly = this.enableOnly
      this.$props.block_contorler.getSelectedFieldName = ()=>{return this.selectedFieldName}
    }
    bus.$on("onSearchClear",() =>{
      this.localValue = ""
      this.updateValue("")
      this.clearAll();
      this.$store.state.last_filter_options = {};
      this.$store.state.last_filter_options2 = {};
    });
    bus.$on("onSearchClearById",(obj) =>{
      if(this.selectedFieldName == obj.field_id && parseInt(this.block_id) > parseInt(obj.block_id)){
        this.localValue = ""
        this.updateValue("")
        this.clearAll();
        this.$store.state.last_filter_options = {};
        this.$store.state.last_filter_options2 = {};
      }
    });
    if(this.block_id == 1 || this.block_id == "1"){
        bus.$on("onOpenPageFilter",(data) =>{
          this.onFilterTypeSelected(data.field, ()=>{
            this.localValue = data.val
            this.updateValue(data.val)
            if(typeof data.cb == "function"){
              data.cb()
            }
          })
        });
    }else if(this.block_id == 2 || this.block_id == "2"){
        bus.$on("onOpenPageFilter2",(data) =>{
          this.onFilterTypeSelected(data.field, ()=>{
            this.localValue = data.val
            this.updateValue(data.val)
            if(typeof data.cb == "function"){
              data.cb()
            }
          })
        });
    }else if(this.block_id == 3 || this.block_id == "3"){
        bus.$on("onOpenPageFilter3",(data) =>{
          this.onFilterTypeSelected(data.field, ()=>{
            this.localValue = data.val
            this.updateValue(data.val)
            if(typeof data.cb == "function"){
              data.cb()
            }
          })
        });
    }
  },
  afterMount() {},
  beforeDestroy() {
    bus.$off("onSearchClear");
    bus.$off("onSearchClearById");
    if(this.block_id == 1 || this.block_id == "1"){
        bus.$off("onOpenPageFilter");
    }else if(this.block_id == 2 || this.block_id == "2"){
        bus.$off("onOpenPageFilter2");
    }else if(this.block_id == 3 || this.block_id == "3"){
        bus.$off("onOpenPageFilter3");
    }
  },
  props: ['field_names','block_id','id','all_disabled',"block_contorler"]
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// search_control_block.vue?122fbb21